import React, { useState, useEffect } from "react";
import DOMPurify from "dompurify";
import HTMLParse from "html-react-parser";
import { EditorState, convertToRaw, Modifier, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftjsToHtml from "draftjs-to-html";
import htmlToDraftjs from "html-to-draftjs";
import {
  Form,
  Row,
  Col,
  Button,
  Modal,
  ListGroup,
  Tooltip,
  OverlayTrigger,
  Dropdown,
} from "react-bootstrap";
import Offcanvas from "react-bootstrap/Offcanvas";
import Switch from "react-switch";
import { useDispatch, useSelector } from "react-redux";
import Axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import moment from "moment";

import MediaCanvas from "../../../../../administration/pods/media/canvas";

//ACTIONS

import * as MediaActions from "../../../../../store/actions/media";
import * as GS_contentSettingsActions from "../../../../../store/actions/globalSettings/GS_contentSettings";
import * as GS_navSettingsActions from "../../../../../store/actions/globalSettings/GS_navSettings";

//STYLES
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import * as NewPostStyles from "../styles/newPost";

function NewPost(props) {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [tab, setTab] = useState("Settings");
  const [previewText, setPreviewText] = useState("");
  const [settings, setSettings] = useState({
    tab: "Settings",
    title: "",
    dateCreated: "",
    dateModified: "",
    publishStart: new Date(),
    publishEnd: "",
    message: "",
  });
  const [editItem, setEditItem] = useState(-1);
  const [dateCreated, setDateCreated] = useState("");
  const navigate = useNavigate();
  const params = useParams();

  const [modal, setModal] = useState({
    header: "",
    open: false,
    message: "",
    error: false,
  });

  function handleCloseModal() {
    setModal((prevState) => {
      return { ...prevState, open: false };
    });
  }

  const media = useSelector((state) => state.media);
  const GS_contentSettings = useSelector((state) => state.GS_contentSettings);
  const dispatch = useDispatch();

  useEffect(() => {
    if (props.modify) {
      dispatch(GS_navSettingsActions.UpdateTitle("Modify Post"));
      getPost();
    } else {
      dispatch(GS_contentSettingsActions.RefreashImages([]));
      dispatch(GS_navSettingsActions.UpdateTitle("New Post"));
    }
    dispatch(GS_navSettingsActions.UpdateSizing(1));
  }, []);

  function getPost() {
    const data = { id: params.postID };
    Axios.post("/pods/CPOD_BLOGS_ADMIN/getPost", data)
      .then((res) => {
        const data = res.data;
        console.log(data);
        const editorStateM = stringToDraftjs(data.post.content);
        setEditorState(editorStateM);
        const date = moment(data.post.dateCreated, "DD/MM/YYYY HH:mm");
        setDateCreated(moment(date.format("DD/MM/YYYY"), "DD/MM/YYYY"));

        const publishStartDate = data.post.publishStart.split("/");
        const publishEndDate = data.post.publishEnd.split("/");

        setSettings((prevState) => {
          return {
            ...prevState,
            dateCreated: data.post.dateCreated,
            dateModified: data.post.dateModified,
            title: data.post.title,
            publishStart: Date.parse(
              `${publishStartDate[1]}/${publishStartDate[0]}/${publishStartDate[2]}`
            ),
            publishEnd:
              data.post.publishEnd != ""
                ? Date.parse(
                    `${publishEndDate[1]}/${publishEndDate[0]}/${publishEndDate[2]}`
                  )
                : "",
          };
        });
        dispatch(GS_contentSettingsActions.LoadImagesFromDatabase(data.images));
        handlePreview(editorStateM, data.images);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function stringToDraftjs(text) {
    const blocksFromHTML = htmlToDraftjs(text);
    const { contentBlocks, entityMap } = blocksFromHTML;
    const contentState = ContentState.createFromBlockArray(
      contentBlocks,
      entityMap
    );

    return EditorState.createWithContent(contentState);
  }

  function handleCloseMediaCanvas() {
    dispatch(MediaActions.UpdateGallerySideBarOpen(false));
  }

  const handleEditorChange = (editorState) => {
    setEditorState(editorState);
    handlePreview(editorState, GS_contentSettings.images);
  };

  const [previewModal, setPreviewModal] = useState({
    open: false,
    html: "",
  });

  function handlePreviewModalClose() {
    setPreviewModal({ open: false });
  }

  function handleTitleChange(event) {
    const { value } = event.target;

    setSettings((prevState) => {
      return { ...prevState, title: value };
    });
  }

  function checkDatesToContine() {
    let check = true;

    const startDate = moment(settings.publishStart, "DD/MM/YYYY");

    let endDate = "";
    if (settings.publishEnd != "") {
      endDate = moment(settings.publishEnd, "DD/MM/YYYY");
    }

    if (settings.publishEnd && endDate.isBefore(startDate)) {
      check = false;
      setModal({
        error: true,
        header: "New Post",
        message:
          "The Publish End Date connect not be before the Publish Start Date",
        open: true,
      });
    }

    if (props.modify) {
      if (startDate.isBefore(dateCreated)) {
        check = false;
        setModal({
          error: true,
          header: "New Post",
          message:
            "The Publish Start Date connect not be before the creation date",
          open: true,
        });
      }
      console.log(dateCreated.format());
    } else {
      if (startDate.isBefore(moment().startOf("day"))) {
        check = false;
        setModal({
          error: true,
          header: "New Post",
          message: "The Publish Start Date connect not be in the past",
          open: true,
        });
      }
    }

    return check;
  }

  function handleSaveBtn() {
    if (settings.title == "") {
      setModal({
        error: true,
        header: "Title",
        message: "Please enter a title",
        open: true,
      });
    } else if (checkDatesToContine()) {
      let continu = true;
      for (const image of GS_contentSettings.images) {
        if (image.url == "") {
          continu = false;
          setModal({
            error: true,
            header: "Images",
            message: "Please delete the images without a URL",
            open: true,
          });
        }
      }
      if (continu) {
        if (props.modify) {
          const data = {
            uuid: params.postID,
            title: settings.title,
            content: DOMPurify.sanitize(
              draftjsToHtml(convertToRaw(editorState.getCurrentContent()))
            ),
            images: GS_contentSettings.images,
            deletedImages: GS_contentSettings.deleted,
            publishStart: moment(settings.publishStart).format("DD/MM/YYYY"),
            publishEnd:
              settings.publishEnd == ""
                ? ""
                : moment(settings.publishEnd).format("DD/MM/YYYY"),
          };
          Axios.post("/pods/CPOD_BLOGS_ADMIN/updatePost", data)
            .then((res) => {
              const data = res.data;
              if (data.error == "null") {
                dispatch(GS_navSettingsActions.UpdateSizing(3));
                navigate(-1);
              } else {
                console.log(data.message);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          const data = {
            blogUUID: params.blogID,
            title: settings.title,
            content: DOMPurify.sanitize(
              draftjsToHtml(convertToRaw(editorState.getCurrentContent()))
            ),
            images: GS_contentSettings.images,
            publishStart: moment(settings.publishStart).format("DD/MM/YYYY"),
            publishEnd:
              settings.publishEnd == ""
                ? ""
                : moment(settings.publishEnd).format("DD/MM/YYYY"),
          };
          Axios.post("/pods/CPOD_BLOGS_ADMIN/insertNewPost", data)
            .then((res) => {
              const data = res.data;
              if (data.error == "null") {
                dispatch(GS_navSettingsActions.UpdateSizing(3));
                navigate(-1);
              } else {
                console.log(data.message);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    }
  }

  function handlePreview(editorState, images) {
    let editorText = DOMPurify.sanitize(
      draftjsToHtml(convertToRaw(editorState.getCurrentContent()))
    );
    let continu = true;

    for (const image of images) {
      if (image.url == "") {
        continu = false;
        setModal({
          error: true,
          header: "Image not found!",
          message: `${image.id} is missing an url`,
          open: true,
        });
        return;
      } else {
        editorText = editorText.replace(
          `{${image.id}}`,
          `<img src="/content/${image.url}" width=${image.width} height=${image.height}/>`
        );
      }
    }
    setPreviewText(editorText);
  }

  function sectionsButtonClick(event) {
    const { name } = event.target;
    setSettings((prevState) => {
      return { ...prevState, tab: name };
    });
  }

  function handleInsertImageButton() {
    let prevID = 0;
    if (GS_contentSettings.images.length > 0) {
      prevID =
        GS_contentSettings.images[GS_contentSettings.images.length - 1].id;
      prevID = Number(prevID.replace("image", ""));
    }

    const id = `image${prevID + 1}`;

    const image = {
      uuid: "null",
      id: id,
      url: "",
      width: 100,
      height: 100,
      status: "create",
    };

    dispatch(GS_contentSettingsActions.UpdateImages(image));
  }

  function handleOpenMediaCanvas(id) {
    dispatch(GS_contentSettingsActions.UpdateImageID(id));
    dispatch(MediaActions.UpdateGallerySideBarOpen(true));
  }

  function truncateString(str, size) {
    return str.length > size ? str.substr(0, size - 1) + "..." : str;
  }

  function handleInsertImageIntoText(id) {
    const image = `{${id}}`;

    const selection = editorState.getSelection();
    const contentState = editorState.getCurrentContent();
    let nextEditorState = EditorState.createEmpty();
    const nextContentState = Modifier.replaceText(
      contentState,
      selection,
      image
    );
    nextEditorState = EditorState.push(
      editorState,
      nextContentState,
      "insert-characters"
    );
    handleEditorChange(nextEditorState);
  }

  function handleChangeTab(tab) {
    setSettings((prevState) => {
      return { ...prevState, tab: tab };
    });
  }

  function handleEditItem(id) {
    setEditItem(id);
  }

  function handleEditBack() {
    setEditItem(-1);
  }

  function handleDeleteImage(id) {
    dispatch(GS_contentSettingsActions.DeleteImage(id));
  }

  function handleImageSizeChange(event, measurement, id) {
    const { value } = event.target;

    dispatch(GS_contentSettingsActions.changeImageSize(id, measurement, value));

    handlePreview(editorState, GS_contentSettings.images);
  }

  //SETTINGS
  function handleStartDateChange(date) {
    setSettings((prevState) => {
      return { ...prevState, publishStart: date };
    });
  }

  function handleEndDateChange(date) {
    setSettings((prevState) => {
      return { ...prevState, publishEnd: date };
    });
  }

  return (
    <div style={NewPostStyles.body}>
      <Row>
        <Col style={NewPostStyles.textSize}>
          <div>
            <Form.Group style={NewPostStyles.newItemTitle}>
              <Form.Label style={NewPostStyles.newItemTitleText}>
                Title:
              </Form.Label>
              <Form.Control
                type="text"
                value={settings.title}
                onChange={handleTitleChange}
              />
            </Form.Group>
          </div>
        </Col>
        <Col style={NewPostStyles.textSize}>
          <Row>
            <Col style={NewPostStyles.textSize}>
              <strong>Preview: </strong>
            </Col>
            <Col style={NewPostStyles.saveButton}>
              <Button onClick={handleSaveBtn}>Save</Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col>
          <Row>
            <Col>
              <Editor
                editorState={editorState}
                toolbar={{
                  options: [
                    "inline",
                    "blockType",
                    "fontSize",
                    "fontFamily",
                    "list",
                    "textAlign",
                    "colorPicker",
                    "link",
                    "embedded",
                    "emoji",
                    "remove",
                    "history",
                  ],
                }}
                onEditorStateChange={handleEditorChange}
                wrapperStyle={NewPostStyles.editorWrapper}
                editorStyle={NewPostStyles.editorStyle}
              />
            </Col>
          </Row>
          <Row>
            <br />
            <br />
            <br />
            <Col>
              <Row style={NewPostStyles.tabControlledArea}>
                <Col>
                  <Row>
                    <Col
                      style={
                        settings.tab == "Settings"
                          ? NewPostStyles.selectedTab
                          : NewPostStyles.tab
                      }
                      onClick={handleChangeTab.bind(this, "Settings")}
                    >
                      Settings
                    </Col>
                    <Col
                      style={
                        settings.tab == "Images"
                          ? NewPostStyles.selectedTab
                          : NewPostStyles.tab
                      }
                      onClick={handleChangeTab.bind(this, "Images")}
                    >
                      Images
                    </Col>
                    {props.modify && (
                      <Col
                        style={
                          settings.tab == "Details"
                            ? NewPostStyles.selectedTab
                            : NewPostStyles.tab
                        }
                        onClick={handleChangeTab.bind(this, "Details")}
                      >
                        Details
                      </Col>
                    )}
                  </Row>
                  <Row>
                    <Col style={NewPostStyles.tabContent}>
                      {settings.tab == "Settings" && (
                        <div>
                          <Row>
                            <Col>
                              Start Publishing:
                              <br />
                              <DatePicker
                                dateFormat="dd/MM/yyyy"
                                selected={settings.publishStart}
                                onChange={(date: Date) =>
                                  handleStartDateChange(date)
                                }
                              />
                              <br /> <br /> End Publishing: <br />
                              <DatePicker
                                dateFormat="dd/MM/yyyy"
                                selected={settings.publishEnd}
                                onChange={(date: Date) =>
                                  handleEndDateChange(date)
                                }
                              />
                            </Col>
                          </Row>
                        </div>
                      )}
                      {settings.tab == "Images" && (
                        <div>
                          <Row>
                            <Col style={NewPostStyles.insertImageButton}>
                              <Button onClick={handleInsertImageButton}>
                                Add Image
                              </Button>
                            </Col>
                          </Row>
                          {GS_contentSettings.images.length > 0 ? (
                            <div>
                              <Row>
                                <Col>Image ID</Col>
                                <Col>Image URL</Col>
                                <Col></Col>
                                <Col></Col>
                              </Row>
                              <ListGroup style={NewPostStyles.scrollable250}>
                                {GS_contentSettings.images.map(
                                  (item, index) => {
                                    return (
                                      <div key={index}>
                                        {editItem == index ? (
                                          <div>
                                            <ListGroup.Item>
                                              <Row>
                                                <Col sm={2}>{item.id}</Col>
                                                <Col sm={4}>
                                                  {truncateString(item.url, 30)}
                                                </Col>
                                                <Col sm={2}>
                                                  Width <br />
                                                  <Form.Control
                                                    type="text"
                                                    value={item.width}
                                                    onChange={(event) =>
                                                      handleImageSizeChange(
                                                        event,
                                                        "width",
                                                        index
                                                      )
                                                    }
                                                  />
                                                </Col>
                                                <Col sm={2}>
                                                  Height
                                                  <Form.Control
                                                    type="text"
                                                    value={item.height}
                                                    onChange={(event) =>
                                                      handleImageSizeChange(
                                                        event,
                                                        "height",
                                                        index
                                                      )
                                                    }
                                                  />
                                                </Col>
                                                <Col sm={2}>
                                                  <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                      <Tooltip>Delete</Tooltip>
                                                    }
                                                  >
                                                    <Button
                                                      onClick={handleDeleteImage.bind(
                                                        this,
                                                        index
                                                      )}
                                                    >
                                                      <i className="fa-solid fa-trash-can"></i>
                                                    </Button>
                                                  </OverlayTrigger>
                                                  <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                      <Tooltip>Back</Tooltip>
                                                    }
                                                  >
                                                    <Button
                                                      onClick={handleEditBack}
                                                    >
                                                      <i className="fa-solid fa-circle-left"></i>
                                                    </Button>
                                                  </OverlayTrigger>
                                                </Col>
                                              </Row>
                                            </ListGroup.Item>
                                          </div>
                                        ) : (
                                          <div>
                                            <ListGroup.Item key={index}>
                                              <Row>
                                                <Col sm={2}>{item.id}</Col>
                                                <Col sm={4}>
                                                  {truncateString(item.url, 30)}
                                                </Col>
                                                <Col sm={2}>
                                                  <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                      <Tooltip>
                                                        Find Image
                                                      </Tooltip>
                                                    }
                                                  >
                                                    <Button
                                                      onClick={handleOpenMediaCanvas.bind(
                                                        this,
                                                        index
                                                      )}
                                                    >
                                                      <i className="fa-solid fa-magnifying-glass"></i>
                                                    </Button>
                                                  </OverlayTrigger>
                                                </Col>
                                                <Col sm={2}>
                                                  <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                      <Tooltip>
                                                        Insert Image
                                                      </Tooltip>
                                                    }
                                                  >
                                                    <Button
                                                      onClick={handleInsertImageIntoText.bind(
                                                        this,
                                                        item.id
                                                      )}
                                                    >
                                                      <i className="fa-solid fa-circle-arrow-right"></i>
                                                    </Button>
                                                  </OverlayTrigger>
                                                </Col>
                                                <Col sm={2}>
                                                  <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                      <Tooltip>Edit</Tooltip>
                                                    }
                                                  >
                                                    <Button
                                                      onClick={handleEditItem.bind(
                                                        this,
                                                        index
                                                      )}
                                                    >
                                                      <i className="fa-solid fa-pen-to-square"></i>
                                                    </Button>
                                                  </OverlayTrigger>
                                                </Col>
                                              </Row>
                                            </ListGroup.Item>
                                          </div>
                                        )}
                                      </div>
                                    );
                                  }
                                )}
                              </ListGroup>
                            </div>
                          ) : null}
                        </div>
                      )}
                      {settings.tab == "Details" && (
                        <div>
                          <Row>
                            <Col>
                              Date Created: <br />
                              {settings.dateCreated} <br /> <br /> Date
                              Modified: <br /> {settings.dateModified}
                            </Col>
                          </Row>
                        </div>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col style={NewPostStyles.previewContainer}>
          {HTMLParse(DOMPurify.sanitize(previewText))}
        </Col>
      </Row>
      <Modal show={modal.open} onHide={handleCloseModal}>
        <Modal.Header
          closeButton
          style={
            modal.error
              ? NewPostStyles.errorModalColor
              : NewPostStyles.successModalColor
          }
        >
          <Modal.Title>{modal.header}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modal.message}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={previewModal.open} onHide={handlePreviewModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>{HTMLParse(DOMPurify.sanitize(previewModal.html))}</div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handlePreviewModalClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Offcanvas
        style={NewPostStyles.mediaCanvas}
        show={media.canvas_open}
        onHide={handleCloseMediaCanvas}
        placement="start"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Media - Choose an image </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <MediaCanvas />
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
}

export default NewPost;
